import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase with retry logic
const initializeFirebase = async (retries = 3) => {
  for (let i = 0; i < retries; i++) {
    try {
      const app = initializeApp(firebaseConfig);
      const auth = getAuth(app);
      const db = getFirestore(app);
      const functions = getFunctions(app);
      const storage = getStorage(app);

      // Add connection state listener
      auth.onAuthStateChanged((user) => {
        if (user) {
          console.log('User is authenticated');
        } else {
          console.log('User is not authenticated');
        }
      }, (error) => {
        console.error('Auth state change error:', error);
      });

      return { app, auth, db, functions, storage };
    } catch (error) {
      console.error(`Firebase initialization attempt ${i + 1} failed:`, error);
      if (i === retries - 1) throw error;
      await new Promise(resolve => setTimeout(resolve, 1000 * (i + 1))); // Exponential backoff
    }
  }
};

// Initialize Firebase with error handling
let app, auth, db, functions, storage;
try {
  const initialized = await initializeFirebase();
  app = initialized.app;
  auth = initialized.auth;
  db = initialized.db;
  functions = initialized.functions;
  storage = initialized.storage;
} catch (error) {
  console.error('Failed to initialize Firebase after retries:', error);
  // You might want to show a user-friendly error message here
}

// Connect to emulators in development
if (process.env.NODE_ENV === 'development') {
  try {
    connectAuthEmulator(auth, 'http://localhost:9099');
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectFunctionsEmulator(functions, 'localhost', 5001);
    connectStorageEmulator(storage, 'localhost', 9199);
  } catch (error) {
    console.error('Error connecting to emulators:', error);
  }
}

export { app, auth, db, functions, storage };